import {
  type GrowthBookSourceAttributes,
  updateGrowthBookConfig as updateGrowthBookConfigInLoader,
} from '@doxyme/config';
import { getGrowthBookAttributes } from '../../shared/growthBook';

export type UseGrowthBookConfigReturn = {
  updateGrowthBookConfig: (
    config?: GrowthBookSourceAttributes,
  ) => Promise<void>;
};

export const useGrowthBookConfig = (): UseGrowthBookConfigReturn => {
  const updateGrowthBookConfig = async (
    config?: GrowthBookSourceAttributes,
  ): Promise<void> => {
    if (config) {
      return updateGrowthBookConfigInLoader(config);
    }

    const growthBookAttributes = await getGrowthBookAttributes();
    return updateGrowthBookConfigInLoader(growthBookAttributes);
  };

  return {
    updateGrowthBookConfig,
  };
};
